import { render, staticRenderFns } from "./nav-top.vue?vue&type=template&id=6c24fcba&scoped=true&"
import script from "./nav-top.vue?vue&type=script&lang=js&"
export * from "./nav-top.vue?vue&type=script&lang=js&"
import style0 from "./nav-top.vue?vue&type=style&index=0&id=6c24fcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24fcba",
  null
  
)

export default component.exports